import React from 'react';
import { configure, mount } from 'enzyme';
import Adapter from 'enzyme-adapter-react-16';
import LinSummary from './LinSummary';
import {
    CUSTOM_INSTALL,
    LINUX,
    M11_5_03,
    LINUX_11_5_03,
} from '../../../../Utils/Constants';
import { loadData } from '../../../../Utils/DataLoader';
import { pageObjects } from '../../../../Utils/LinuxDataLoader';
import { initializePageObjectsMap } from '../../../../Utils/PageObjectsMapUtil';

configure({ adapter: new Adapter() });

let wrapper = null;
describe('LinSummary', () => {
    loadData(LINUX_11_5_03);
    initializePageObjectsMap(pageObjects);
    beforeEach(() => {
        jest.mock('../../../Navigation/Navigation', () => 'Nav');
        wrapper = mount(
            <LinSummary
                nextStep={jest.fn()}
                backStep={jest.fn()}
                steps={9}
                getOriginState={jest.fn().mockReturnValue('mock state value')}
                setOriginState={jest.fn()}
                setBasicState={jest.fn()}
                deepestStep={9}
                useOs={LINUX}
                useMode={CUSTOM_INSTALL}
                useVersion={M11_5_03}
            />
        );
    });

    it('Test if the Summary Page has been rendered', () => {
        expect(wrapper.find('.summaryContainer')).toHaveLength(1);
    });
});
